import React, { Component } from 'react';
import ProgressBar from '../../artzu-ui/src/ProgressBar';
import MediaQuery from 'react-responsive';
import { Redirect } from 'react-router-dom';
import SideBarContent from '../SideBar/SideBarContent';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import Loading from '../shared/Loading';
import Header from './Header';
import PromotionDetail from './PromotionDetail';
import ReferAFriend from './ReferAFriend';
import './index.css';

const query = gql`
  query promotion {
    currentUser {
      id
      hoursThisWeek
      bookingsThisWeek
      referralCode
      referralUrl
      status
      operatingCity
      referrals {
        referredUserName
        referredUserMobile
        referralStatus
        referredUserNameTemp
        hoursDriven
      }
    }
  }
`;
class Promotion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      display: 'index',
      header: 'Promotions'
    };
  }

  render() {
    const { display, header } = this.state;
    const { status, loggedIn } = this.props;
    return (
      <Query query={query} fetchPolicy="network-only">
        {({ loading, error, data, refetch }) => {
          if (loading)
            return (
              <div className="load-div">
                <Loading size="3x" />
              </div>
            );
          if (['blacklisted'].includes(status))
            return <Redirect to="/profile" />;

          const hoursBooked =
            data && data.currentUser && data.currentUser.bookingsThisWeek;
          const hoursDriven =
            data && data.currentUser && data.currentUser.hoursThisWeek;
          const city =
            data && data.currentUser && data.currentUser.operatingCity;
          return (
            <div className="container">
              <div className="promotion-index">
                <MediaQuery maxWidth={767}>
                  <Header
                    header={header}
                    backAction={
                      display === 'index'
                        ? () => this.props.history.goBack()
                        : () =>
                            this.handleDisplayChange('index', 'Promotions')
                    }
                  />
                  {display === 'index' ? (
                    <div className="promotion-all">
                      <p className="promo-all-head">Weekly Promotions</p>
                      <div className="promo-sec">
                        <p className="promo-desc">
                          {this.generatePromoMsg('fiftyHour')}
                        </p>
                        {loggedIn ? (
                          <div className="progress-display">
                            <ProgressBar
                              fillers={[
                                hoursBooked === 0
                                  ? 0
                                  : Math.max(
                                      Math.min(
                                        (hoursBooked * 100) / 50,
                                        100
                                      ),
                                      12
                                    ),
                                hoursDriven === 0
                                  ? 0
                                  : Math.max(
                                      Math.min(
                                        (hoursDriven * 100) / 50,
                                        100
                                      ),
                                      12
                                    )
                              ]}
                              className="promo-pbar"
                              borderColor="#414141"
                              primaryColor="#414141"
                              secondaryColor="#128dff"
                            />
                            <p>{hoursBooked}/50</p>
                          </div>
                        ) : null}
                        <p>
                          Drive 50 hours a week (resets on Monday{' '}
                          {city === 'toronto' ? '4AM' : '2AM'}) and receive
                          $50 credit.
                        </p>
                        {loggedIn ? (
                          <a
                            href="javascript:void(0)"
                            onClick={() =>
                              this.handleDisplayChange(
                                'fiftyHour',
                                '50hr Promotion'
                              )
                            }
                            style={{ textDecoration: 'underline' }}>
                            View
                          </a>
                        ) : null}
                      </div>
                      <div className="promo-sec">
                        <p className="promo-desc">
                          {this.generatePromoMsg('eightyHour')}
                        </p>
                        {loggedIn ? (
                          <div className="progress-display">
                            <ProgressBar
                              fillers={[
                                hoursBooked === 0
                                  ? 0
                                  : Math.max(
                                      Math.min(
                                        (hoursBooked * 100) / 80,
                                        100
                                      ),
                                      12
                                    ),
                                hoursDriven === 0
                                  ? 0
                                  : Math.max(
                                      Math.min(
                                        (hoursDriven * 100) / 80,
                                        100
                                      ),
                                      12
                                    )
                              ]}
                              className="promo-pbar"
                              borderColor="#414141"
                              primaryColor="#414141"
                              secondaryColor="#128dff"
                            />
                            <p>{hoursBooked}/80</p>
                          </div>
                        ) : null}
                        <p>
                          Drive 80 hours a week (resets on Monday{' '}
                          {city === 'toronto' ? '4AM' : '2AM'}) and receive
                          an additional $50 credit.
                        </p>
                        {loggedIn ? (
                          <a
                            href="javascript:void(0)"
                            onClick={() =>
                              this.handleDisplayChange(
                                'eightyHour',
                                '80hr Promotion'
                              )
                            }
                            style={{ textDecoration: 'underline' }}>
                            View
                          </a>
                        ) : null}
                      </div>
                      <div className="promo-refer">
                        <p className="promo-desc">
                          Refer a friend to receive $50
                        </p>
                        <p>
                          Refer a friend to drive with Autzu and both
                          existing and new driver will receive a $50
                          credit.
                        </p>
                        {loggedIn ? (
                          <a
                            href="javascript:void(0)"
                            onClick={() =>
                              this.handleDisplayChange(
                                'refer',
                                'Refer a Friend'
                              )
                            }
                            style={{ textDecoration: 'underline' }}>
                            View
                          </a>
                        ) : null}
                      </div>
                    </div>
                  ) : null}
                  {display === 'fiftyHour' ? (
                    <PromotionDetail
                      promoGoal={50}
                      hoursBooked={hoursBooked}
                      hoursDriven={hoursDriven}
                      handleDisplayChange={this.handleDisplayChange}
                      promotionMessage={this.generatePromoMsg('fiftyHour')}
                      rules={this.rules()}
                      header={header}
                    />
                  ) : null}
                  {display === 'eightyHour' ? (
                    <PromotionDetail
                      promoGoal={80}
                      hoursBooked={hoursBooked}
                      hoursDriven={hoursDriven}
                      handleDisplayChange={this.handleDisplayChange}
                      promotionMessage={this.generatePromoMsg(
                        'eightyHour'
                      )}
                      rules={this.rules()}
                      header={header}
                    />
                  ) : null}
                  {display === 'refer' ? (
                    <ReferAFriend
                      referralUrl={data.currentUser.referralUrl}
                      referralCode={data.currentUser.referralCode}
                      status={data.currentUser.status}
                      handleDisplayChange={this.handleDisplayChange}
                      promotionMessage={this.generatePromoMsg('refer')}
                      rules={this.rules()}
                      referrals={data.currentUser.referrals}
                    />
                  ) : null}
                </MediaQuery>
                <MediaQuery minWidth={768}>
                  <div className="desktop-subheader">Promotions</div>
                  <div className="sidebar-container">
                    <SideBarContent status={status} signedIn={loggedIn} />
                  </div>
                  <div className="desktop-promo">
                    <div className="promotion-all">
                      <p className="promo-all-head">Weekly Promotions</p>
                      <div className="promo-sec">
                        <p className="promo-desc">
                          {this.generatePromoMsg('fiftyHour')}
                        </p>
                        {loggedIn ? (
                          <div className="progress-display">
                            <ProgressBar
                              fillers={[
                                hoursBooked === 0
                                  ? 0
                                  : Math.max(
                                      Math.min(
                                        (hoursBooked * 100) / 50,
                                        100
                                      ),
                                      12
                                    ),
                                hoursDriven === 0
                                  ? 0
                                  : Math.max(
                                      Math.min(
                                        (hoursDriven * 100) / 50,
                                        100
                                      ),
                                      12
                                    )
                              ]}
                              className="promo-pbar"
                              borderColor="#414141"
                              primaryColor="#414141"
                              secondaryColor="#128dff"
                            />
                            <p>{hoursBooked}/50</p>
                          </div>
                        ) : null}
                        <p>
                          Drive 50 hours a week (resets on Monday{' '}
                          {city === 'toronto' ? '4AM' : '2AM'}) and receive
                          $50 credit.
                        </p>
                        {loggedIn ? (
                          <a
                            href="javascript:void(0)"
                            onClick={() =>
                              this.handleDisplayChange(
                                'fiftyHour',
                                '50hr Promotion'
                              )
                            }
                            style={{ textDecoration: 'underline' }}>
                            View
                          </a>
                        ) : null}
                      </div>
                      <div className="promo-sec">
                        <p className="promo-desc">
                          {this.generatePromoMsg('eightyHour')}
                        </p>
                        {loggedIn ? (
                          <div className="progress-display">
                            <ProgressBar
                              fillers={[
                                hoursBooked === 0
                                  ? 0
                                  : Math.max(
                                      Math.min(
                                        (hoursBooked * 100) / 80,
                                        100
                                      ),
                                      12
                                    ),
                                hoursDriven === 0
                                  ? 0
                                  : Math.max(
                                      Math.min(
                                        (hoursDriven * 100) / 80,
                                        100
                                      ),
                                      12
                                    )
                              ]}
                              className="promo-pbar"
                              borderColor="#414141"
                              primaryColor="#414141"
                              secondaryColor="#128dff"
                              header={header}
                            />
                            <p>{hoursBooked}/80</p>
                          </div>
                        ) : null}
                        <p>
                          Drive 80 hours a week (resets on Monday{' '}
                          {city === 'toronto' ? '4AM' : '2AM'}) and receive
                          an additional $50 credit.
                        </p>
                        {loggedIn ? (
                          <a
                            href="javascript:void(0)"
                            onClick={() =>
                              this.handleDisplayChange(
                                'eightyHour',
                                '80hr Promotion'
                              )
                            }
                            style={{ textDecoration: 'underline' }}>
                            View
                          </a>
                        ) : null}
                      </div>
                      <div className="promo-refer">
                        <p className="promo-desc">
                          Refer a friend to receive $50
                        </p>
                        <p>
                          Refer a friend to drive with Autzu and both
                          existing and new driver will receive a $50
                          credit.
                        </p>
                        {loggedIn ? (
                          <a
                            href="javascript:void(0)"
                            onClick={() =>
                              this.handleDisplayChange(
                                'refer',
                                'Refer a Friend'
                              )
                            }
                            style={{ textDecoration: 'underline' }}>
                            View
                          </a>
                        ) : null}
                      </div>
                    </div>
                    <div className="desktop-promo-details">
                      {display === 'fiftyHour' ? (
                        <PromotionDetail
                          promoGoal={50}
                          hoursBooked={hoursBooked}
                          hoursDriven={hoursDriven}
                          handleDisplayChange={this.handleDisplayChange}
                          promotionMessage={this.generatePromoMsg(
                            'fiftyHour'
                          )}
                          rules={this.rules()}
                          header={header}
                          media="desktop"
                        />
                      ) : null}
                      {display === 'eightyHour' ? (
                        <PromotionDetail
                          promoGoal={80}
                          hoursBooked={hoursBooked}
                          hoursDriven={hoursDriven}
                          handleDisplayChange={this.handleDisplayChange}
                          promotionMessage={this.generatePromoMsg(
                            'eightyHour'
                          )}
                          rules={this.rules()}
                          header={header}
                          media="desktop"
                        />
                      ) : null}
                      {display === 'refer' ? (
                        <ReferAFriend
                          referralUrl={data.currentUser.referralUrl}
                          referralCode={data.currentUser.referralCode}
                          status={data.currentUser.status}
                          handleDisplayChange={this.handleDisplayChange}
                          promotionMessage={this.generatePromoMsg('refer')}
                          rules={this.rules()}
                          referrals={data.currentUser.referrals}
                          media="desktop"
                        />
                      ) : null}
                    </div>
                  </div>
                </MediaQuery>
              </div>
            </div>
          );
        }}
      </Query>
    );
  }

  handleDisplayChange = (display, header) => {
    this.setState({ display, header });
  };

  generatePromoMsg = promo => {
    switch (promo) {
      case 'fiftyHour':
        return 'Drive 50 hours to receive $50';
      case 'eightyHour':
        return 'Drive 80 hours to receive an additional $50';
      case 'refer':
        return 'Refer a friend to drive with Autzu - both you and new driver will receive a $50 credit';
      default:
        return null;
    }
  };

  rules = () => {
    switch (this.state.display) {
      case 'fiftyHour':
        return (
          <ul>
            <li>
              Weekly hours accumulate from Monday 4:00am until the
              following Monday 3:59am.
            </li>
            <li>
              You need to drive 50 hours worth of bookings within the week.
            </li>
            <li>
              Promotion only applies if your account is in good standing
              (including but not limited to: positive balance, no flags on
              account).
            </li>
            <li>
              Autzu reserves the right to withdraw, amend or cancel a
              promotion offer at any time. Any revised version will be
              effective immediately when available on the website.
            </li>
          </ul>
        );
      case 'eightyHour':
        return (
          <ul>
            <li>
              Weekly hours accumulate from Monday 4:00am until the
              following Monday 3:59am.
            </li>
            <li>
              You need to drive 80 hours worth of bookings within the week.
            </li>
            <li>
              Promotion only applies if your account is in good standing
              (including but not limited to: positive balance, no flags on
              account).
            </li>
            <li>
              Autzu reserves the right to withdraw, amend or cancel a
              promotion offer at any time. Any revised version will be
              effective immediately when available on the website.
            </li>
          </ul>
        );
      case 'refer':
        return (
          <ul>
            <li>
              Share your referral link to your friend to get them to sign
              up; or
            </li>
            <li>
              During the sign up process, when it asks "How did you hear
              about us" ask your friend to select "Autzu Referral Code" and
              enter your code
            </li>
            <li>
              Your friend must complete 20 hours worth of bookings before
              you both receive a $50 credit.
            </li>
          </ul>
        );
      default:
        return null;
    }
  };
}

export default Promotion;



// WEBPACK FOOTER //
// ./src/components/Promotion/index.js